import React, { useEffect, useRef, useState } from "react";
import { useNavigate, UNSAFE_NavigationContext } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiImageAddFill } from "react-icons/ri";
import '../../../AdminStyle.css';
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { uploadImage } from "../../../CommonComponents/ImageUpload";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { MagnifyImage } from "../../../CommonComponents/MagnifyImage";

const useBlocker = (message, when) => {
    const { navigator } = React.useContext(UNSAFE_NavigationContext);

    useEffect(() => {
        if (!when) return;

        const originalPush = navigator.push;
        const originalReplace = navigator.replace;

        // Intercept navigation
        navigator.push = (...args) => {
            if (window.confirm(message)) {
                originalPush(...args);
            }
        };

        navigator.replace = (...args) => {
            if (window.confirm(message)) {
                originalReplace(...args);
            }
        };

        return () => {
            navigator.push = originalPush;
            navigator.replace = originalReplace;
        };
    }, [message, when, navigator]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (when) {
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [message, when]);
};

function AddItems() {

    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_PP_URL;

    const [isDirty, setIsDirty] = useState(false);
    useBlocker('Are you sure you want to leave this page?', isDirty);
    const [imagePreviews, setImagePreviews] = useState([]);
    // HANDLE IMAGE SECTION    
    const [loading, setLoading] = useState(false);
    const handleFileChange = async (e) => {
        setLoading(true);
        setIsDirty(true);
        try {
            const files = e.target.files;
            const validFiles = Array.from(files).filter((file) => {
                if (file.size > 100 * 1024) { // 100KB in bytes
                    alert(`${file.name} is too large (${file.size} bytes).`);
                    return false; // Exclude files larger than 100KB
                }
                return true; // Include files <= 100KB
            });
            for (const file of validFiles) {
                const imageUrl = await uploadImage(file);
                if (imageUrl) {
                    setImagePreviews((prev => [...prev, imageUrl]));
                }
            };
        } catch (e) {
            console.log(e, "error in image upload");
        } finally {
            setLoading(false);
            e.target.value = "";
        }
    };

    const handleDeleteImage = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this item?");
        if (confirmDelete) {
            const newPreviews = imagePreviews.filter((_, i) => i !== index);
            setImagePreviews(newPreviews); // Update previews
        }
    };

    const capitalizeWords = (value) => {
        return value
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };

    // SUCCESS POPUP
    const [action, setAction] = useState();
    const [showPop, setShowPop] = useState(false);
    const [extraBtn, setExtraBtn] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();
    const navToCat = useNavigate();
    const confirmPopUp = () => {
        setShowPop(false);
        setNavv('ok');
        saveItem("ok");
    };

    const onCloseBtn = () => {
        setAction('');
        setExtraBtn();
        setMore('');
        setShowPop(false);
    };

    const onMoreBtn = () => {
        setShowPop(false);
        setNavv('');
        setExtraBtn("addMore");
        saveItem("addMore");
    };


    const token = sessionStorage.getItem('tokenKey');

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState();

    const [customerDescription, setCustomerDescription] = useState();
    const [weight, setWeight] = useState();
    const [mrp, setMrp] = useState();
    const [sequenceNo, setSequenceNo] = useState();
    const [sellingPrice, setSellingPrice] = useState();
    const [parentCategoryUuids, setParentCategoryUuids] = useState([]);
    const [subCategoryUuids, setSubCategoryUuids] = useState([]);
    const [offerApplicable, setOfferApplicable] = useState(true);
    const [taxUuid, setTaxUuid] = useState();
    const [publisherUuid, setPublisherUuid] = useState();
    const [getMedium, setGetMedium] = useState();
    const [videoUrl, setVideoUrl] = useState();
    const [isFreeShipping, setIsFreeShipping] = useState(false);
    const [otherDataJson, setOtherDataJson] = useState({
        medium: getMedium?.label,
        author: "",
        noOfPages: "",
        publicationYear: "",
        hsnCode: "4901",
    });
    useEffect(() => {
        setOtherDataJson((prev) => ({
            ...prev, medium: getMedium?.label
        }))
    }, [getMedium]);

    const content = {
        title: capitalizeWords(title),
        sequenceNo: 0,
        description: description,
        customerDescription: customerDescription,
        weight: weight,
        mrp: mrp,
        sequenceNo: sequenceNo,
        itemImageUrls: imagePreviews.map((itm) => itm?.responsePacket),
        sellingPrice: sellingPrice,
        parentCategoryUuids: parentCategoryUuids?.map(itm => itm.value),
        subCategoryUuids: subCategoryUuids?.map(itm => itm.value),
        offerApplicable: offerApplicable,
        taxUuid: taxUuid?.value,
        publisherUuid: publisherUuid?.value,
        otherDataJson: JSON.stringify(otherDataJson),
        videoUrl: videoUrl,
        isFreeShipping: isFreeShipping
    };

    const [selectMedium, setSelectMedium] = useState([
        { value: "1", label: "Hindi", },
        { value: "2", label: "English" },
        { value: "3", label: "Bilingual" },
        { value: "4", label: "Urdu" },
        { value: "5", label: "Sanskrit" },
    ]);

    const handleOnChange = (key, value) => {
        setIsDirty(true);
        setOtherDataJson((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    // SAVE ITEMS API
    const [isSubmitting, setIsSubmitting] = useState(false);
    const saveItem = async (okk) => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/save`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                if (okk === "addMore") {
                    setTitle('');
                    setDescription('');
                    setWeight('');
                    setMrp('');
                    setSequenceNo('');
                    setSellingPrice('');
                    setParentCategoryUuids([]);
                    setSubCategoryUuids([]);
                    setSubCat([]);
                    setGetMedium('');
                    setOtherDataJson({
                        medium: '',
                        author: "",
                        noOfPages: "",
                        publicationYear: "",
                        hsnCode: "4901",
                    });
                    setImagePreviews([]);
                    setPublisherUuid('')
                    if (subCat !== '') {
                        setFilterSubCat([...subCat]);
                        setManageSubCat([]);
                    };
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
                    });

                    setAction('');
                    setExtraBtn();
                    setMore('');
                } else if (okk === 'ok') {
                    navToCat(-1);
                }
            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv();
                setMore('OK');
                setExtraBtn();
            }
        } catch (e) {
            console.log(e, "error in add itme api");
            setShowPop(true);
            setAction('something went wrong');
            setMore("OK");
            setNavv();
            setExtraBtn();
        } finally {
            setIsSubmitting(false);
        }
    };

    // SELECT CATEGORY 
    const [seletedCat, setSelectedCat] = useState([]);
    const [filterCat, setFilterCat] = useState([]);

    const saveCat = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setSelectedCat(getRes.responsePacket);
                setFilterCat(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'errorn in add item select parent cate api')
        }
    };

    useEffect(() => {
        const parentCategoryData = seletedCat.map((itm) => ({
            value: itm.value,
            label: itm.label,
        }));
        setFilterCat(parentCategoryData);
    }, [seletedCat]);

    useEffect(() => {
        saveCat();
    }, []);

    // SUB CATEGPRY
    const [subCat, setSubCat] = useState([]);
    const [filterSubCat, setFilterSubCat] = useState([]);
    useEffect(() => {
        const subCateDataset = subCat.map((itm) => ({
            value: itm.value,
            label: itm.label
        }));
        setFilterSubCat(subCateDataset);
    }, [subCat]);

    const saveSub = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    parentCategoryUuids: parentCategoryUuids?.map(itm => itm.value)
                })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setSubCat(getRes.responsePacket);
            } else {
                console.log('error in savasub api responce')
            }
        } catch (e) {
            console.log(e, 'error in sub category in add  item')
        }
    };

    useEffect(() => {
        if (parentCategoryUuids !== '') {
            saveSub();
        }
        if (parentCategoryUuids.length === 0) {
            setSubCat([]);
            setFilterSubCat([]);
            setManageSubCat([]);
            setSubCategoryUuids([]);
        }
    }, [parentCategoryUuids]);

    useEffect(() => {
        const updatedManageSubCat = manageSubCat.filter((item) =>
            subCat.some((subItem) => subItem.value === item.value));
        const updateSubUuid = subCategoryUuids.filter((item) =>
            subCat.some((subItem) => subItem.value === item.value)
        )
        setSubCategoryUuids(updateSubUuid);
        setManageSubCat(updatedManageSubCat);
    }, [subCat]);

    const [manageSubCat, setManageSubCat] = useState([]);

    const [errors, setErrors] = useState({});
    const titleRef = useRef(null);
    const mrpRef = useRef(null);
    const sellingPriceRef = useRef(null);
    const weightRef = useRef(null);
    const parentCateRef = useRef(null);
    const mediumReff = useRef(null);
    const publisherRef = useRef(null);
    const hsnCodeRef = useRef(null);
    const taxRef = useRef(null);

    const handleValidation = () => {
        let newErrors = {};
        if (!title?.trim()) newErrors.title = "Title is required.";
        if (parentCategoryUuids?.length === 0 && subCategoryUuids?.length === 0) newErrors.parentCategoryUuids = "tax Category is required.";
        if (!mrp?.trim() || Number(mrp) < Number(sellingPrice)) newErrors.mrp = "tax Category is required.";
        if (!sellingPrice?.trim() || Number(sellingPrice) > Number(mrp)) newErrors.sellingPrice = "tax Category is required.";
        if (!weight?.trim()) newErrors.weight = "tax Category is required.";
        if (!otherDataJson?.medium) newErrors.medium = "Medium is required.";
        if (!publisherUuid) newErrors.publisher = "Publisher is required.";
        if (!taxUuid) newErrors.taxCat = "tax Category is required.";
        if (!otherDataJson?.hsnCode.trim()) newErrors.hsnCode = "HSN Code is required.";
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }
        return true;
    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "medium":
                mediumReff.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "publisher":
                publisherRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "hsnCode":
                hsnCodeRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "taxCat":
                taxRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "weight":
                weightRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "sellingPrice":
                sellingPriceRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "mrp":
                mrpRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "parentCategoryUuids":
                parentCateRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };


    const handleSubmit = () => {
        if (handleValidation()) {
            setAction("Confirm submit");
            setShowPop(true);
            setNavv("OK");
            setExtraBtn("Add More");
            setMore("Cancel")
        }
    };

    const [publisherList, setPublisherList] = useState([]);
    const [filterPublisherList, setFilterPublisherList] = useState([...publisherList]);

    const getPublisherList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/publisher/list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setPublisherList(getRes.responsePacket);
                setFilterPublisherList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'error in publisher api')
        }
    };
    useEffect(() => {
        getPublisherList();
    }, []);

    const [taxList, setTaxList] = useState([]);
    const [filtertaxList, setFilterTaxList] = useState([...taxList]);
    useEffect(() => {
        setTaxUuid({ value: filtertaxList[0]?.value, label: filtertaxList[0]?.label });
    }, [filtertaxList]);

    const getTaxList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/tax/list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setTaxList(getRes.responsePacket);
                setFilterTaxList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'error in publisher api')
        }
    };
    useEffect(() => {
        getTaxList();
    }, []);

    // Image Magifinify
    const [imgUrl, setImgUrl] = useState();
    const [showImg, setShowImg] = useState(false);
    const maginifyImage = (e) => {
        setShowImg(true);
        setImgUrl(e);
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Add Item </h4>
                        </div>
                        <div className="category-btn">
                            <div className="btn submit-btn" style={{ marginTop: "0px" }}>
                                <button onClick={handleSubmit} style={{ backgroundColor: "black", color: "white", marginTop: "0px", marginRight: "25px" }}>Submit</button>
                            </div>
                            <button onClick={() => navigate("/admin/item")}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />
                    <div className="main-container">
                        <div className="add-form" ref={titleRef}>
                            {/* Title Input */}
                            <div className="add w-100 m-b2">
                                <label style={errors.title && { color: "red" }}>Title *</label>
                                <input
                                    type="text"
                                    name="title"
                                    value={title}
                                    style={{ textTransform: 'capitalize' }}
                                    onChange={(e) => { setTitle(e.target.value); setIsDirty(true) }}
                                />
                            </div>

                            {/* Category Input */}
                            <div className="d-flex w-100 m-b2 d-other" ref={parentCateRef}>
                                <div className="add parentid">
                                    <label style={errors.parentCategoryUuids && { color: "red" }}>Category</label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        name="colors"
                                        options={filterCat.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={parentCategoryUuids}
                                        onChange={(e) => { setParentCategoryUuids(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>

                                <div className="add parentid">
                                    <label style={errors.parentCategoryUuids && { color: "red" }}>Select Sub Category</label>

                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        name="colors"
                                        options={filterSubCat.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={subCategoryUuids}
                                        onChange={(e) => { setSubCategoryUuids(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>
                            </div>

                            {/* MRP Input */}
                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add" ref={mrpRef}>
                                    <label style={errors.mrp && { color: "red" }}>MRP *</label>
                                    <input
                                        type="number"
                                        value={mrp}
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => { setMrp(e.target.value); setIsDirty(true) }}
                                    />
                                </div>
                                <div className="add " ref={sellingPriceRef}>
                                    <label style={errors.sellingPrice && { color: "red" }}>Selling Price *</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        // placeholder="Selling Price"
                                        onChange={(e) => { setSellingPrice(e.target.value); setIsDirty(true) }}
                                        value={sellingPrice}
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="availableAllTime"
                                            checked={offerApplicable}
                                            onChange={() => { setOfferApplicable(!offerApplicable); setIsDirty(true) }}
                                            id="check-box"
                                        />
                                        <label htmlFor="check-box">Coupon available for item</label>
                                    </div>
                                </div>

                                <div className="add" ref={weightRef}>
                                    <label style={errors.weight && { color: "red" }}>Weight *</label>
                                    <div className="btn-AddCat" >
                                        <input
                                            type="number"
                                            onChange={(e) => { setWeight(e.target.value); setIsDirty(true) }}
                                            value={weight}
                                            onKeyDown={(e) => {
                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        <button>gm</button>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add parentid" ref={mediumReff}>
                                    <label style={errors.medium && { color: "red" }}>Medium *</label>

                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={selectMedium.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={getMedium}
                                        onChange={(e) => { setGetMedium(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>

                                <div className="add parentid" ref={publisherRef}>
                                    <label style={errors.publisher && { color: "red" }}>Publisher *</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={filterPublisherList.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={publisherUuid}
                                        onChange={(e) => { setPublisherUuid(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">

                                <div className="add ">
                                    <label>Author</label>
                                    <input
                                        type="text"
                                        value={otherDataJson.author}
                                        style={{ textTransform: 'capitalize' }}
                                        onChange={(e) => handleOnChange("author", e.target.value)}
                                    />
                                </div>

                                <div className="add ">
                                    <label>No. of Pages</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.noOfPages}
                                        onChange={(e) => handleOnChange("noOfPages", e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">

                                <div className="add" >
                                    <label>Publication Year</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.publicationYear}
                                        onChange={(e) => handleOnChange("publicationYear", e.target.value)}
                                    />
                                </div>

                                <div className="add" ref={taxRef}>
                                    <label style={errors.taxCat && { color: "red" }}>Tax Category *</label>
                                    <Select
                                        defaultValue={taxUuid?.[0]}
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={filtertaxList.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={taxUuid}
                                        onChange={(e) => { setTaxUuid(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other" >
                                <div className="add parentid" ref={hsnCodeRef}>
                                    <label style={errors.hsnCode && { color: "red" }}>HSN Code *</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.hsnCode}
                                        onChange={(e) => { handleOnChange("hsnCode", e.target.value) }}
                                    />
                                </div>
                                <div className="add parentid">
                                    <label>Video URL</label>
                                    <input
                                        type="text"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        // onWheel={(e) => e.target.blur()}
                                        value={videoUrl}
                                        onChange={(e) => { setVideoUrl(e.target.value); setIsDirty(true) }}
                                    />
                                </div>

                            </div>
                            <div className="d-flex m-b2 check-box-avail">
                                <input
                                    type="checkbox"
                                    name="isFreeShipping"
                                    checked={isFreeShipping}
                                    onChange={() => { setIsFreeShipping(!isFreeShipping); setIsDirty(true) }}
                                    id="freeShipping-box"
                                />
                                <label htmlFor="freeShipping-box">Free Shipping</label>
                            </div>

                            <div className="editer m-b2">
                                <div className="add w-100">
                                    <label>Key Word</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                            setIsDirty(true)
                                        }}
                                    />

                                </div>
                            </div>

                            <div className="editer m-b2">
                                <div className="add w-100">
                                    <label>Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={customerDescription}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setCustomerDescription(data);
                                            setIsDirty(true);
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Category Icon File Upload */}
                            <div className="add w-100">
                                <label>Item Images</label>
                                {/* Input Section */}
                                <div className="input-img">
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        multiple
                                        id="category-icon"
                                        style={{ display: 'none' }}
                                    />
                                    {
                                        imagePreviews.length > 0 ?
                                            (
                                                loading ?
                                                    <div className="loading-container">
                                                        <div className="spinner"></div>
                                                        <p>Loading...</p>
                                                    </div>
                                                    :
                                                    <label htmlFor="category-icon" tabIndex="0" onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            document.getElementById("category-icon").click();
                                                        }
                                                    }}>
                                                        <div className="custom-label">
                                                            <RiImageAddFill />
                                                            <span>Add more</span>
                                                        </div>
                                                    </label>
                                            )
                                            :
                                            (
                                                loading ?
                                                    <div className="loading-container">
                                                        <div className="spinner"></div>
                                                        <p>Loading...</p>
                                                    </div>
                                                    :
                                                    <label htmlFor="category-icon" className="custom-file-input" tabIndex="0" onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            document.getElementById("category-icon").click();
                                                        }
                                                    }}>
                                                        <div className="text">
                                                            <div className="icon">
                                                                <h1><IoCloudUploadOutline /></h1>
                                                                <h4>Add Images</h4>
                                                            </div>
                                                        </div>
                                                    </label>
                                            )
                                    }
                                </div>

                                {/* Image Preview Section */}
                                {
                                    imagePreviews.length > 0 && !loading && <div className="image-preview-wrapper">
                                        {
                                            imagePreviews.map((preview, index) => (
                                                <div key={index} className="image-preview-container">
                                                    <img
                                                        src={preview.responsePacket}
                                                        alt={`Category Icon ${index + 1}`}
                                                        style={{ objectFit: 'cover' }}
                                                        onClick={() => maginifyImage(preview.responsePacket)}
                                                        loading="lazy"
                                                    />
                                                    {/* Delete Button */}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteImage(index)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-5px',
                                                            left: '-5px',
                                                            background: 'red',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            width: '25px',
                                                            height: '25px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        X
                                                    </button>
                                                </div>
                                            ))}
                                    </div>
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </div>


            {/* POPUP MODAL */}

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                moreBtn={extraBtn}
                onMoreBtn={onMoreBtn}
                navv={navv}
                FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
            />

            <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />

        </>
    );
}

export default AddItems;